<template>
  <div class="px-1 py-1">
    <div
      v-for="column in columns"
      :key="column.id"
      class="flex items-center justify-between gap-8 rounded-md px-3 py-2 hover:bg-surface-muted">
      <span class="text-sm">{{ column.title }}</span>
      <button
        type="button"
        class="relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full transition-colors duration-200"
        :class="isHidden(column.id) ? 'bg-border-subtle' : ''"
        :style="!isHidden(column.id) ? 'background-color: var(--color-action)' : ''"
        @click="toggle(column.id)">
        <span
          class="pointer-events-none mt-0.5 inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform duration-200"
          :class="isHidden(column.id) ? 'translate-x-0.5' : 'translate-x-4'" />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { useColumnPrefsStore } from '@/stores/columnPrefsStore'
import { mapActions, mapState } from 'pinia'

export default {
  name: 'OrdersColumnPickerMenu',
  props: {
    tableId: {
      type: String,
      required: true,
    },
    columns: {
      type: Array as () => { id: string; title: string }[],
      required: true,
    },
  },
  computed: {
    ...mapState(useColumnPrefsStore, ['hiddenColumnIDs']),
    currentHiddenIDs(): string[] {
      return this.hiddenColumnIDs[this.tableId] ?? []
    },
  },
  methods: {
    ...mapActions(useColumnPrefsStore, ['toggleColumn']),
    isHidden(id: string): boolean {
      return this.currentHiddenIDs.includes(id)
    },
    toggle(id: string) {
      this.toggleColumn(this.tableId, id)
    },
  },
}
</script>
